import { useToasts } from 'react-toast-notifications'
import React from 'react';

export function withToast(Component) {
    return function WrappedComponent(props) {
      const toastFuncs = useToasts()
      return <Component {...props} {...toastFuncs} />;
    }
  }